import { render } from "./CardHeader.vue?vue&type=template&id=172ab012&scoped=true&ts=true"
import script from "./CardHeader.vue?vue&type=script&lang=ts"
export * from "./CardHeader.vue?vue&type=script&lang=ts"

import "./CardHeader.vue?vue&type=style&index=0&id=172ab012&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-172ab012"]])

export default __exports__